import React, { useState } from 'react';
import { Button, Grid, Radio, FormControlLabel, FormControl, RadioGroup, Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import join from 'url-join';
import { ApiServerUrl } from '../../config.json';
import ErrorIcon from '@material-ui/icons/Error';
import Modal from '../Modal/modal';
import { useLang } from '../../util/lang';
import style from '../../pages/css/patients.module.css';
import { updateLastOpenCaseId } from '../../store/NewCase/NewCase.action';
import { useDispatch } from 'react-redux';
import { useCreateNewCaseOptions } from './use-create-new-case-option';

export default function NewCaseModalContent({
    productMatrix,
    caseOptionTypeArr,
    currentPatientId,
    currentCaseId,
    LinkToFunc,
    selectCaseOptionType,
    handleCaseOptionTypeChange,
}) {
    const [OpenCaseOptionTypeDialog, setSelectCaseOptionTypeDialog] = useState(false);
    const dispatch = useDispatch();
    const handleOpenCaseOptionDescription = () => {
        setSelectCaseOptionTypeDialog(true);
    };
    const { availableNewCaseOptions } = useCreateNewCaseOptions(productMatrix);
    const get = useLang('Patients');
    return (
        <>
            <Grid container>
                <p style={{ color: 'red', lineHeight: '1.5em' }}>
                    <strong>{get('no_down_grade_reminder')}</strong>
                </p>
                {availableNewCaseOptions?.map((v, _) => {
                    return (
                        <Grid
                            item
                            xs={6}
                            sm={3}
                            style={{ textAlign: 'center', padding: '4px 4px' }}
                            key={`TrioClear-${v.case_type}`}
                        >
                            <Link
                                onClick={() => {
                                    if (currentCaseId != null && currentCaseId != undefined) {
                                        dispatch(updateLastOpenCaseId(currentCaseId));
                                    }
                                }}
                                to={LinkToFunc(v, selectCaseOptionType, currentPatientId)}
                                className={style.NewCaseModalLink}
                                style={{ color: 'unset', textDecoration: 'none' }}
                            >
                                <div className={style.NewCaseModalBackground}></div>
                                <Button
                                    className={style.NewCaseModalButton}
                                    style={{ backgroundColor: v['color_code'] }}
                                >
                                    <img
                                        className={style.NewCaseModalImage}
                                        src={join(ApiServerUrl, `/file/config/${v.product_image}`)}
                                    />
                                    <div className={style.NewCaseModalName}>{v['product_name'].toUpperCase()}</div>
                                    <div
                                        className={
                                            v['product_desc'] == null || v['product_desc'].length === 0
                                                ? style.NewCaseModalNoDescription
                                                : style.NewCaseModalDescription
                                        }
                                    >
                                        <ul>
                                            {v['product_desc']?.split(/\r?\n/).map((v) => (
                                                <li key={v}>{v}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </Button>
                            </Link>
                        </Grid>
                    );
                })}
            </Grid>
            <span className={style.NewCaseModalRemark}>*Please refer to Clinician Manual for more details.</span>

            <Grid container>
                {caseOptionTypeArr.length > 0 ? (
                    caseOptionTypeArr.map((type, index) => (
                        <FormControl key={index}>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                onChange={handleCaseOptionTypeChange}
                                value={selectCaseOptionType}
                            >
                                <Box display="flex" alignItems="center">
                                    <FormControlLabel value={type.opt1} control={<Radio />} label={type.opt1} />
                                    <FormControlLabel value={type.opt2} control={<Radio />} label={type.opt2} />
                                    <ErrorIcon
                                        onClick={handleOpenCaseOptionDescription}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Modal
                                        className="modal"
                                        title={get('@NewPatient.NewCaseOption.CaseOptionDescription')}
                                        open={OpenCaseOptionTypeDialog}
                                        handleClose={() => setSelectCaseOptionTypeDialog(false)}
                                        modalSize="sm"
                                        submitButton={false}
                                    >
                                        {type.description}
                                    </Modal>
                                </Box>
                            </RadioGroup>
                        </FormControl>
                    ))
                ) : (
                    <></>
                )}
            </Grid>
        </>
    );
}
